'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIAvatar = require('./UIAvatar');

var _UIAvatar2 = _interopRequireDefault(_UIAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UISimpleAvatar = function (_Component) {
  _inherits(UISimpleAvatar, _Component);

  function UISimpleAvatar() {
    _classCallCheck(this, UISimpleAvatar);

    return _possibleConstructorReturn(this, (UISimpleAvatar.__proto__ || Object.getPrototypeOf(UISimpleAvatar)).apply(this, arguments));
  }

  _createClass(UISimpleAvatar, [{
    key: 'render',
    value: function render() {
      _devLogger2.default.warn({
        message: 'UISimpleAvatar is depreciated, please use UIAvatar or UIImage please',
        key: 'UISimple-avatar-is-out'
      });
      return _react2.default.createElement(_UIAvatar2.default, this.props);
    }
  }]);

  return UISimpleAvatar;
}(_react.Component);

UISimpleAvatar.propTypes = _UIAvatar2.default.propTypes;
exports.default = UISimpleAvatar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.493/js/UISimpleAvatar.js
// module id = 1031
// module chunks = 2 3